<body class="h-screen flex justify-center items-center">
<div class="text-center">
  <img src="../../../../assets/images/branding/YSC-logo.png" alt="Logo" class="mb-4 mx-auto">
  <p class="text-h6 m-6">Reset password for your account</p>
  <form [formGroup]="resetPasswordForm" (ngSubmit)="onResetPasswordClicked()" class="space-y-4 text-start">
    <div class="flex flex-col gap-2">
      <app-text-input [type]="'password'" formControlName="password" [label]="'Password'"
                      placeholder="********" class="w-full" [fullWidth]="true"></app-text-input>
      <app-text-input [type]="'password'" formControlName="confirmPassword" [label]="'Confirm Password'"
                      placeholder="*********" class="w-full" [fullWidth]="true"></app-text-input>
      @if (resetPasswordForm.hasError('passwordsMismatch')) {
        <div class="text-error-500 text-caption">Please ensure both passwords are the same.</div>
      }
    </div>
    <div>
      <div class="flex justify-center items-center py-4 gap-2">
        <p class="text-body2">Already have an account?</p>
        <a class="cursor-pointer text-info-500" (click)="onLoginClicked()">Login</a>
      </div>
      <app-button [fullWidth]="true" type="submit" [loading]="resetPasswordState.loading()">Reset Password
      </app-button>
    </div>
  </form>
</div>
</body>
